import React, { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown } from 'react-feather';
import { Modal } from 'carbon-components-react';
import CustomButton from '../../components/custom-button/custom-btn.component';
import './order-classes.styles.scss';
import { useCustomMutation } from '@/utils/useCustomMutation';
import { postMethod } from '@/api/common';

export default function OrderClassesModal({
  openModal,
  classes,
  cancelAction,
  refreshClasses,
}) {
  const [localClasses, setLocalClasses] = useState([]);

  useEffect(() => {
    setLocalClasses([...classes]);
  }, [classes]);

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...localClasses];
    const temp = updated[index];
    updated[index] = updated[index - 1];
    updated[index - 1] = temp;
    setLocalClasses(updated);
  };

  const moveDown = (index) => {
    if (index === localClasses.length - 1) return;
    const updated = [...localClasses];
    const temp = updated[index];
    updated[index] = updated[index + 1];
    updated[index + 1] = temp;
    setLocalClasses(updated);
  };

  const { trigger, isMutating, error, reset } = useCustomMutation(
    `class/order-positions `,
    (url, { arg }) => postMethod(url, arg),
  );

  function handleClose() {
    reset();
    cancelAction();
    setLocalClasses(classes);
  }

  const handleOrderSave = async () => {
    const orderedClassIds = localClasses.map((c, index) => ({
      classId: c.id,
      position: index + 1,
    }));

    trigger(orderedClassIds, {
      onSuccess: () => {
        refreshClasses();
        handleClose();
      },
    });
  };

  return (
    <Modal
      id="order-classes-modal"
      className="big-modal order-classes-modal"
      hasScrollingContent
      passiveModal={true}
      open={openModal}
      modalHeading="Order Classes"
      primaryButtonDisabled={false}
    >
      <div>
        <p className="text-label mb-20">
          Arrange classes in ascending order to define their hierarchy.
        </p>

        <div className="order-classes-list">
          {localClasses
            // .sort((a, b) => a.classPosition - b.classPosition)
            .map((item, index) => (
              <div key={item.id} className="order-classes-row">
                <span className="order-classes-index">{index + 1}.</span>
                <span className="order-classes-description">
                  {item.description}
                </span>
                <div className="order-classes-actions">
                  <button
                    type="button"
                    className="order-classes-btn"
                    disabled={index === 0}
                    onClick={() => moveUp(index)}
                  >
                    <ChevronUp size="18" />
                  </button>
                  <button
                    type="button"
                    className="order-classes-btn"
                    disabled={index === localClasses.length - 1}
                    onClick={() => moveDown(index)}
                  >
                    <ChevronDown size="18" />
                  </button>
                </div>
              </div>
            ))}
        </div>

        {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}

        <div className="order-classes-buttons mt-20">
          <CustomButton
            classes="outline danger font-bold"
            onClick={handleClose}
          >
            CLOSE
          </CustomButton>
          <CustomButton
            classes="primary font-bold"
            onClick={handleOrderSave}
            isLoading={isMutating}
          >
            SAVE ORDER
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
}
